import { useState, useCallback } from 'react';

export const useUnitState = () => {
  const [openUnits, setOpenUnits] = useState<Set<number>>(new Set());

  const toggleUnit = useCallback((unitId: number) => {
    setOpenUnits(prev => {
      const newSet = new Set(prev);
      if (newSet.has(unitId)) {
        newSet.delete(unitId);
      } else {
        newSet.add(unitId);
      }
      return newSet;
    });
  }, []);

  const isUnitOpen = useCallback((unitId: number) => {
    return openUnits.has(unitId);
  }, [openUnits]);

  const closeUnit = useCallback((unitId: number) => {
    setOpenUnits(prev => {
      const newSet = new Set(prev);
      newSet.delete(unitId);
      return newSet;
    });
  }, []);

  const openUnit = useCallback((unitId: number) => {
    setOpenUnits(prev => {
      const newSet = new Set(prev);
      newSet.add(unitId);
      return newSet;
    });
  }, []);

  return {
    openUnits,
    toggleUnit,
    isUnitOpen,
    closeUnit,
    openUnit
  };
};